import { render } from "./one_secondary.vue?vue&type=template&id=16935408&scoped=true"
import script from "./one_secondary.vue?vue&type=script&lang=js"
export * from "./one_secondary.vue?vue&type=script&lang=js"

import "./one_secondary.vue?vue&type=style&index=0&id=16935408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16935408"]])

export default __exports__